<template>
	<div class="row">
		<div class="col-sm-6" v-for="(item, index) in data" :key="index">
			<item-importation v-bind="{ item, index, lines }" />
		</div>
	</div>
</template>
<script>
	import ItemImportation from './components/item-importation';

	export default {
		components: {
			ItemImportation,
		},
		props: {
			data: {
				default: () => ({}),
			},
			lines: {
				default: null,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/import/components/exames-nao-importados/index.vue